module.exports = __webpack_public_path__ + "img/DE01736.22b53996.png";